module.exports = __webpack_public_path__ + "static/media/Maps-Diagram.c560199c.png";